import { useQuery } from '@apollo/client';
import queries from '@nc-aftermarket/config/queryDefs';
import Alert from '../components/Alert';
import Loader from '../components/Loader';
import Meta from '../components/Meta';
import SaleCarousel from '../components/SaleCarousel';

const carouselClassName = 'tw-my-10 xl:tw-my-12';

function getPropsFromCollection(collection, data) {
  const { heading, slug, subheading, theme } = collection;
  return {
    heading,
    link: `/${slug}/`,
    sales: collection.sales.items,
    showSeeAllLink: true,
    subheading,
    theme,
  };
}

export default function Home() {
  const { data, error, loading } = useQuery(queries.MarketHome, {
    fetchPolicy: 'cache-first',
    pollInterval: 1000 * 60 * 5, // Refresh query every 5 minutes
    variables: {
      newMinStartTime: Math.floor(Date.now() / 1000) - 24 * 60 * 60,
      pageSize: 20,
    },
  });

  if (error) {
    return (
      <div className="tw-wrap tw-mt-4">
        <Alert error={error} />
      </div>
    );
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="tw-bg-near-white tw-py-1">
      <Meta
        canonical="https://www.namecheap.com/market/"
        description="Namecheap Marketplace is the place to buy and sell domain names at auction. Buy domains instantly or bid in a domain auction to grab the perfect domain name."
        robots="all"
        title="Buy &amp; Sell Domains - Domain Name Auctions | Namecheap"
      />
      {Object.values(data?.collections || {}).map(collection => (
        <SaleCarousel
          className={carouselClassName}
          key={collection.slug}
          {...getPropsFromCollection(collection, data)}
        />
      ))}
    </div>
  );
}
